import { ICO_UTM_PARAMS, ICO_UTM_PARAMS_PAGE_SPECIFIC } from '@/constants/ico'

export const ICO_SELL_MY_CAR_UTM_TRACKING = {
  utmCampaign: ICO_UTM_PARAMS_PAGE_SPECIFIC.SELL_MY_CAR.UTM_CAMPAIGN,
  utmContent: ICO_UTM_PARAMS.UTM_CONTENT_FORM,
  utmSource: ICO_UTM_PARAMS.UTM_SOURCE,
}

export const AUTO_BRP_ICO_SELL_MY_CAR_UTM_TRACKING = {
  utmCampaign: ICO_UTM_PARAMS.UTM_CAMPAIGN_AUTO_BRP_ICO,
  utmContent: ICO_UTM_PARAMS.UTM_CONTENT_AUTO_BRP_ICO,
  utmSource: ICO_UTM_PARAMS.UTM_SOURCE,
}

export const ICO_VALUE_CALCULATOR_UTM_TRACKING = {
  utmCampaign: ICO_UTM_PARAMS_PAGE_SPECIFIC.CAR_VALUE_CALCULATOR.UTM_CAMPAIGN,
  utmContent: ICO_UTM_PARAMS.UTM_CONTENT_FORM,
  utmSource: ICO_UTM_PARAMS.UTM_SOURCE,
}
